import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Facebook, Instagram } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  section: {
    marginTop: '4rem',
    background: 'linear-gradient(180deg, transparent 0%, var(--color-pink-blush) 30%, var(--color-pink-soft) 100%)',
    paddingTop: '4rem',
    paddingBottom: '0',
    color: 'var(--color-plum)',
  },
  inner: {
    maxWidth: '1100px',
    margin: '0 auto',
    padding: '0 2rem',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: '0 1rem',
    },
  },
  heading: {
    fontFamily: 'Fraunces, serif',
    fontSize: '2rem',
    fontWeight: 600,
    color: 'var(--color-plum)',
    margin: 0,
    letterSpacing: '-0.01em',
    '& span': {
      fontStyle: 'italic',
      color: 'var(--color-coral)',
    },
  },
  subheading: {
    fontFamily: 'Inter, sans-serif',
    fontSize: '0.95rem',
    color: 'var(--color-text-soft)',
    marginTop: '0.5rem',
    marginBottom: '1.5rem',
  },
  socials: {
    display: 'flex',
    justifyContent: 'center',
    gap: '0.75rem',
    marginBottom: '2rem',
  },
  socialIcon: {
    width: '54px',
    height: '54px',
    backgroundColor: 'var(--color-white)',
    color: 'var(--color-coral)',
    boxShadow: '0 8px 22px rgba(232, 72, 79, 0.18)',
    transition: 'transform .18s ease, background-color .18s ease, color .18s ease',
    '&:hover': {
      backgroundColor: 'var(--color-coral)',
      color: 'var(--color-white)',
      transform: 'translateY(-3px)',
    },
    '& svg': {
      fontSize: '1.6rem',
    },
  },
  bar: {
    marginTop: '2rem',
    padding: '1.75rem 1rem',
    background: 'var(--color-plum)',
    color: 'rgba(255, 255, 255, 0.85)',
    fontFamily: 'Inter, sans-serif',
    fontSize: '0.85rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.75rem',
  },
  copy: {
    color: 'rgba(255, 255, 255, 0.85)',
    textDecoration: 'none',
    fontWeight: 500,
    transition: 'color .18s ease',
    '&:hover': {
      color: 'var(--color-coral-soft)',
    },
  },
  privacy: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '1.5rem',
    fontSize: '0.78rem',
    '& > a': {
      color: 'rgba(255, 255, 255, 0.65)',
      textDecoration: 'none',
      transition: 'color .18s ease',
      '&:hover': {
        color: 'var(--color-white)',
      },
    },
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <footer className={classes.section}>
      <div className={classes.inner}>
        <h2 className={classes.heading}>Volg <span>AllesBon</span></h2>
        <p className={classes.subheading}>Blijf op de hoogte van nieuwe winkels en aanbiedingen</p>
        <div className={classes.socials}>
          <IconButton className={classes.socialIcon} onClick={() => window.open('https://www.instagram.com/allesbon.be/')} aria-label="Instagram">
            <Instagram />
          </IconButton>
          <IconButton className={classes.socialIcon} onClick={() => window.open('https://www.facebook.com/profile.php?id=100092004995731')} aria-label="Facebook">
            <Facebook />
          </IconButton>
        </div>
      </div>
      <div className={classes.bar}>
        <a href="https://www.corbital.be/" target="_blank" rel="noreferrer" className={classes.copy}>&copy; {new Date().getFullYear()} www.corbital.be</a>
        <div className={classes.privacy}>
          <a href="https://stallesbon.blob.core.windows.net/public/TERMSANDCONDITIONS.pdf" target="_blank" rel="noreferrer">Algemene Voorwaarden</a>
          <a href="https://stallesbon.blob.core.windows.net/public/PRIVACYPOLICY.pdf" target="_blank" rel="noreferrer">Privacy Policy</a>
          <a href="https://stallesbon.blob.core.windows.net/public/RETURNPOLICY.pdf" target="_blank" rel="noreferrer">Return Policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
